import * as React from "react";
import * as _ from "lodash";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import IPatientCondition from "../../../models/IPatientCondition";
import IConditionsUI from "../../../models/IConditionsUI";
import IStaticDataValue from "../../../../../common/models/IStaticDataValue";
import SuggestionTagsContainer from "../../../containers/SuggestionTagsContainer";
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";

/**
 * Created by aditya on 27/02/18.
 */
export interface PatientConditionsEditorProps {
    showRelationshipDropdown: boolean,
    staticConditions?: IStaticDataValue[],
    updatedConditions: {item: IConditionsUI}[],
    updateConditions: (updatedConditions: {item: IConditionsUI}[]) => void;
    fetchStaticSymptomData: (name: string) => Promise<any>;
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}

class PatientConditionsEditor extends React.Component<PatientConditionsEditorProps> {

    constructor(props: PatientConditionsEditorProps) {
        super(props);
    }

    onConditionRemove = (index: number) => {
        let currUpdatedConditions = Object.assign([], this.props.updatedConditions);
        currUpdatedConditions.splice(index, 1);
        this.props.updateConditions(currUpdatedConditions);
    }

    onConditionChange = (updatedCondition: {item: IConditionsUI}, index: number) => {
        let currUpdatedConditions = Object.assign([], this.props.updatedConditions);
        if (index >= currUpdatedConditions.length) {
            let newConditionItem = ModelFactory.createNewPatientCondition();
            newConditionItem.internalValue = updatedCondition.item.name;
            newConditionItem.displayValue = updatedCondition.item.name.toLowerCase();
            let formattedItem = ModelFactory.createNewFormattedConditionsItem();
            formattedItem.name = updatedCondition.item.name;
            formattedItem.items = [newConditionItem];
            currUpdatedConditions.push({item: formattedItem})
        } else {
            currUpdatedConditions[index] = updatedCondition;
            _.map(currUpdatedConditions[index].item.items, (item: IPatientCondition) => {
                item.internalValue = updatedCondition.item.name.toLowerCase()
                item.displayValue = updatedCondition.item.name
            })
        }
        this.props.updateConditions(currUpdatedConditions);
    }

    onConditionSuggestionAdd = (suggestionItem: IStaticDataValue) => {
        let patientConditions = Object.assign([], this.props.updatedConditions);
        if (this.props.updatedConditions.filter(item => item.item.name === suggestionItem.displayValue).length === 0) {
            // let newConditionItem = ModelFactory.createNewPatientCondition();
            // newConditionItem.internalValue = suggestionItem.internalValue;
            // newConditionItem.displayValue = suggestionItem.displayValue;
            let formattedItem = ModelFactory.createNewFormattedConditionsItem();
            formattedItem.name = suggestionItem.displayValue;
            formattedItem.items = [];
            patientConditions.push({item: formattedItem})
        }
        this.props.updateConditions(patientConditions);
    }

    appendToRemoveKey = (conditions: {item: IConditionsUI}[]) => {
        let conditionsToReturn = conditions;
        _.map(conditionsToReturn, (condition: {item: any}) => {
            if (condition.item.items.length === 0) {
                condition.item.showRemove = true;
            } else if (condition.item.items.length === 1) {
                if (ModelFactory.isConditionDetailsEmpty(condition.item.items[0]))
                    condition.item.showRemove = true;
                else
                    condition.item.showRemove = false;
            } else {
                condition.item.showRemove = false;
            }
        })
        return conditionsToReturn;
    }

    render() {
        let filteredStaticConditions: IStaticDataValue[] = Object.assign([], this.props.staticConditions);
        let mappedStaticConditions = this.props.staticConditions.map(item => item.displayValue);
        _.map(this.props.updatedConditions, (condition) => {
            let index = mappedStaticConditions.indexOf(condition.item.name);
            if ( index !== -1 ) {
                filteredStaticConditions.splice(index, 1)
                mappedStaticConditions.splice(index, 1)
            }
        })
        return (
            <div className="patient-conditions-editor">
                {
                    !_.isEmpty(this.props.questionnaire) &&
                    <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
                }
                <TemplatedList templateName={"allConditions"} commonProps={{showRelationshipDropdown: this.props.showRelationshipDropdown, fetchStaticSymptomData: this.props.fetchStaticSymptomData}}
                               defaultItem={{item: ModelFactory.createNewFormattedConditionsItem()}}
                               listItems={this.appendToRemoveKey(this.props.updatedConditions)}
                               onItemRemove={this.onConditionRemove}
                               onItemChange={this.onConditionChange}
                />
                {
                    !_.isEmpty(filteredStaticConditions) &&
                    <SuggestionTagsContainer rootClass={"past-conditions"} suggestions={filteredStaticConditions} onTagSelect={this.onConditionSuggestionAdd}/>
                }
            </div>
        );
    }
}

export default PatientConditionsEditor